import { render, staticRenderFns } from "./MargemContribuicaoSidebar.vue?vue&type=template&id=25b793e2&"
import script from "./MargemContribuicaoSidebar.vue?vue&type=script&lang=js&"
export * from "./MargemContribuicaoSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/margem-roi/MargemContribuicaoSidebar.vue
// module id = 1438
// module chunks = 28